module.exports = __webpack_public_path__ + "static/media/natour_medium.1a7aeeb5.jpg";